module.exports = __webpack_public_path__ + "static/media/form-error.399a13c8.svg";